import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;
	display: flex;
	align-items: center;
	padding: 1em 0;

	.content-container {
		.headline {
			font-size: 1.7em;
			font-weight: 700;
			color: #262626;
			text-align: center;
			position: relative;
			margin-bottom: 2em;
		}

		.sections {
			width: 100%;
			position: relative;
			display: flex;
			flex-flow: row nowrap;
			justify-content: space-between;
			align-items: stretch;
			gap: 2em;

			.section-container {
				position: relative;
				box-shadow: 0px 3px 6px #00000029;
				width: 100%;
				height: max-content;
				border-radius: 30px 5px 5px 5px;
				pointer-events: none;

				.section-title {
					font-size: 1.2em;
					font-weight: 400;
					letter-spacing: 4px;
					text-transform: uppercase;
					text-align: center;
					list-style: none;
					display: block;
					background: ${vars.backgroundGoldGradient};
					color: ${vars.colorWhite};
					border-radius: 0px 5px 0 0;
					box-shadow: 0px 3px 6px #00000029;
					padding: 0.5em 0em;
					width: calc(100% - 30px);
					margin: 0 0 0 30px;

					&::-webkit-details-marker {
						display: none;
						visibility: hidden;
					}
				}

				.section-list {
					padding: 2em;

					.section-list-item {
						margin-bottom: 1.3em;
						max-width: 95%;
					}
				}

				.section-icon {
					position: absolute;
					top: -2px;
					left: 0;
					background-color: ${vars.colorWhite};
					border-radius: 50%;
					display: flex;
					place-content: center;
					place-items: center;
					padding: 11px;
					height: max-content;
					width: max-content;
					box-shadow: 0px 3px 6px #00000029;

					.section-icon-svg {
						background-size: 30px 30px;
						background-repeat: no-repeat;
						background-position: center;
						width: 30px;
						height: 30px;

						&.heart {
							background-size: 30px 28px;
							background-position: bottom;
						}
					}
				}
			}
		}
	}

	@media all and (max-width: ${vars.tabletS}) {
		.content-container {
			.sections {
				display: flex;
				flex-direction: column;
				align-items: center;
				gap: 3em;

				.section-container {
					max-height: 2.8em;
					transition: max-height 0.3s ease-in-out;
					pointer-events: all;
					border-radius: 30px 5px 5px 30px;

					.section-title {
						border-radius: 5px;
					}

					.section-list {
						z-index: -1;
						opacity: 0;
						transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
						max-height: 0;
						overflow: hidden;
					}

					&.is-open {
						max-height: 1000px;
						opacity: 1;
						border-radius: 30px 5px 5px 5px;

						.section-list {
							opacity: 1;
							max-height: 1000px;
						}
					}

					.section-icon {
						top: -5px;
						padding: 8px;
						left: -2px;
					}
				}
			}
		}
	}

	@media all and (max-width: ${vars.mobileL}) {
		padding: 1em 0 0 0;
	}

	@media all and (max-width: ${vars.mobileM}) {
		.content-container {
			.sections {
				gap: 4em;
			}
		}
	}
`;
